//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    context: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    date: null,
    modelConfig: {
      mask: 'DD-MM-YYYY',
    },
    attrs: [
      {
        key: 'today',
        highlight: {
          class: 'today',
        },
        dates: new Date(),
      },
    ],
  }),
  computed: {
    pickerAttributes() {
      return Object.assign(this.context.attributes, {id: null, class: null});
    },
    isDisabled() {
      return 'disabled' in this.context.attributes;
    },
  },
  watch: {
    date(newDate) {
      this.context.model = this.$moment(newDate, 'DD-MM-YYYY').format('YYYY-MM-DD');
    },
    'context.model'(newValue) {
      this.date = new Date(newValue);
    },
  },
  mounted() {
    if (this.context.model) {
      this.date = this.context.model;
    }

    this.context.model = this.date;
  },
  methods: {
    parseDate(value) {
      if (this.$moment(value, 'DD-MM-YYYY', true).isValid()) {
        return value;
      }
      return false;
    },
  },
};
